import { Dispatch, SetStateAction } from "react";
import { useStateWithLocalStoragePersistenceAndDefault } from "./useStateWithLocalStoragePersistenceAndDefault";
import { LocalStorageKey } from "../../localStoragePersistence/common/LocalStorageKey";

export default function useToggleValueWithLocalStoragePersistence(
  localStorageKey: LocalStorageKey,
  defaultToggleValue: boolean,
): [boolean, Dispatch<SetStateAction<boolean>>] {
  return useStateWithLocalStoragePersistenceAndDefault(
    localStorageKey,
    defaultToggleValue,
  );
}
